
































export default {
  props: {
    ordersIds: { type: Array, required: true },
    selectedOrderIndex: { type: Number, default: 0 }
  },
  data() {
    return {
      currentIndex: this.selectedOrderIndex + 1
    }
  },
  computed: {
    ordersIdsLength(): number {
      return this.ordersIds.length
    },
    currentSelectedOrder(): number {
      return this.ordersIds[this.currentIndex - 1]
    }
  },
  methods: {
    updateSuggestedLoad(): void {
      this.$emit('updateSuggestedLoad', this.currentSelectedOrder)
    },
    increaseCurrentIndex(): void {
      this.currentIndex++
      this.updateSuggestedLoad()
    },
    decreaseCurrentIndex(): void {
      this.currentIndex--
      this.updateSuggestedLoad()
    }
  }
}
